// extracted by mini-css-extract-plugin
export default {"Pie":"WheelSlice_Pie__2jkjd","Slice":"WheelSlice_Slice__sGRgw","Clicked":"WheelSlice_Clicked__mvY9l"};